/*
 *             Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
import _0x3b5be6 from'./../../message.js';class GetSuggestionMessage extends _0x3b5be6{constructor(_0x231f14,_0x4bda86){super(),this['id']=_0x231f14,this['documentId']=_0x4bda86;}['toJSON'](){return{'id':this['id'],'documentId':this['documentId']};}static['fromJSON'](_0xecb1a0){return new GetSuggestionMessage(_0xecb1a0['id'],_0xecb1a0['documentId']);}}GetSuggestionMessage['TYPE']='103',GetSuggestionMessage['READABLE_TYPE_NAME']='getSuggestion',GetSuggestionMessage['DESCRIPTOR_NAME']='TrackChangesGetSuggestionMessage',GetSuggestionMessage['DESCRIPTOR']={'fields':{'id':{'type':'string','id':0x1},'documentId':{'type':'string','id':0x2}}};export default GetSuggestionMessage;